import { Spacings } from '@styles/index';
import {
  ASSETS,
  REFERRAL_GIFT_VARIANT,
  ReferralGiftVariant
} from '../constants';

export type VariantConfig = {
  title: string;
  highlight: string;
  subtitle: string;
  product: string;
  objectPosition?: string;
  mobileHeadline: [string, string, string];
  mobileSubtitle: [string, string];
};

export type ProductLayout = {
  width: string;
  height: string;
  top: string;
};

export const IPAD_FIGMA = { width: 851, height: 201 };
export const EURO_FIGMA = { width: 657, height: 201 };
export const HUNTER_FIGMA = { width: 1136, height: 201 };
export const PS5_FIGMA = { width: 1085, height: 201 };
export const TOUCHPOINT_TOP_BAND = 101;
export const EURO_ELLIPSE = { left: 390, top: 7, size: 299 };
export const HUNTER_ELLIPSE = { left: 819, top: 7, size: 299 };
export const IPAD_ELLIPSE = { left: 547, top: 9, size: 299 };
export const PS5_ELLIPSE = { left: 768, top: 9, size: 299 };
export const EURO_PRODUCT_WIDTH = 181;
export const HUNTER_PRODUCT_WIDTH = 400;

export const pct = (value: number, total: number) =>
  `${(value / total) * 100}%`;

export const euroProductLeft = () =>
  pct(
    EURO_ELLIPSE.left + EURO_ELLIPSE.size / 2 - EURO_PRODUCT_WIDTH / 2,
    EURO_FIGMA.width
  );

export const PRODUCT_LAYOUT: Record<ReferralGiftVariant, ProductLayout> = {
  [REFERRAL_GIFT_VARIANT.HUNTER]: {
    width: Spacings.SPACING_70B,
    height: Spacings.SPACING_40B,
    top: Spacings.SPACING_7B
  },
  [REFERRAL_GIFT_VARIANT.IPAD]: {
    width: Spacings.SPACING_50B,
    height: Spacings.SPACING_40B,
    top: Spacings.SPACING_8B
  },
  [REFERRAL_GIFT_VARIANT.PS5]: {
    width: Spacings.SPACING_90B,
    height: Spacings.SPACING_50B,
    top: `-${Spacings.SPACING_1B}`
  },
  [REFERRAL_GIFT_VARIANT.EURO_TRIP]: {
    width: Spacings.SPACING_45B,
    height: Spacings.SPACING_50B,
    top: Spacings.SPACING_0B
  }
};

export const VARIANT_CONFIG: Record<ReferralGiftVariant, VariantConfig> = {
  [REFERRAL_GIFT_VARIANT.HUNTER]: {
    title: 'Got what it takes to win a',
    highlight: 'Hunter 350? 👀',
    subtitle: 'Refer friends and get closer to win hunter 350 and more.',
    product: ASSETS.homeHunter,
    mobileHeadline: ['Got what it takes', 'to win a', 'Hunter 350? 👀'],
    mobileSubtitle: [
      'Refer friends and get closer',
      'to win hunter 350 and more.'
    ]
  },
  [REFERRAL_GIFT_VARIANT.IPAD]: {
    title: 'Think you can earn your way to an',
    highlight: 'iPad?  👀',
    subtitle: 'Refer friends and get closer to win IPad and more.',
    product: ASSETS.heroIpad,
    mobileHeadline: ['Think you can earn', 'your way to an', 'iPad? 👀'],
    mobileSubtitle: ['Refer friends and get closer', 'to win IPad and more.']
  },
  [REFERRAL_GIFT_VARIANT.PS5]: {
    title: 'Think you can earn your way to a',
    highlight: 'PS5? 👀',
    subtitle: 'Refer friends and get closer to win PS5 and more.',
    product: ASSETS.touchpointPs5,
    mobileHeadline: ['Think you can earn', 'your way to a', 'PS5? 👀'],
    mobileSubtitle: ['Refer friends and get closer', 'to win PS5 and more.']
  },
  [REFERRAL_GIFT_VARIANT.EURO_TRIP]: {
    title: 'Payment done. Get something back.',
    highlight: 'Win Euro trip for 2 👀',
    subtitle: 'Refer friends and get closer to win Euro trip for 2 and more.',
    product: ASSETS.touchpointEuroTrip,
    objectPosition: 'right bottom',
    mobileHeadline: [
      'Payment done.',
      'Get something back.',
      'Win Euro trip for 2 👀'
    ],
    mobileSubtitle: [
      'Refer friends and get closer',
      'to win Euro trip for 2 and more.'
    ]
  }
};
